<template>
  <img
    class="owal spinner logo"
    src="../assets/img/OSquareNoPadding.png"
  >
</template>

<script>
export default {
  name: 'OwalSpinnerLogo',
}
</script>

<style scoped>

.owal.spinner.logo {
  animation: spinner-spin infinite 1.0s ease-in-out;
  object-fit: contain;
}

@keyframes spinner-spin {
  0% {
    transform: rotate(180deg) scale(0.9);
  }
  50% {
    transform: rotate(-180deg) scale(1.1);
  }
  100% {
    transform: rotate(180deg) scale(0.9);
  }
}

</style>
